// 9fbef606107a605d69c0edbcd8029e5d
import { createSelector } from 'reselect';
import { FAVORITES_REDUCER_KEY } from '../../../../../constants/reducer.constants';
import { TCP, SNJ, GYM, PJP } from '../../../../../constants/brands.constants';

const getFavoriteListState = (state) => {
  return state[FAVORITES_REDUCER_KEY];
};

export const selectWishlistsSummaries = createSelector(
  getFavoriteListState,
  (items) => items && items.get('wishlistsSummaries')
);

export const selectActiveWishList = createSelector(
  getFavoriteListState,
  (items) => items && items.get('activeWishList')
);

export const selectWishListShareStatus = (state) => {
  return state && state.Favorites && state.Favorites.get('isWishListShared');
};

export const wishListFromState = (state) => {
  return state && state.Favorites && state.Favorites.get('defaultWishList');
};

export const getWishlistCount = createSelector(wishListFromState, (defaultWishlist) => {
  return (defaultWishlist && defaultWishlist.items && defaultWishlist.items.length) || 0;
});

export const getToastModalState = createSelector(getFavoriteListState, (fav) =>
  fav.get('toastModalState')
);

export const selectActiveWishlistProducts = (state) => {
  const activeWishList = selectActiveWishList(state);
  return activeWishList && activeWishList.items;
};

export const selectWishlistProducts = (state) => {
  const activeWishList = selectActiveWishList(state);
  const items = activeWishList && activeWishList.items;
  return (
    items && items.sort((a, b) => (a.productInfo?.listPrice < b.productInfo?.listPrice ? 1 : -1))
  );
};

export const selectWishlistSubTotal = createSelector(getFavoriteListState, (items) => {
  const activeWishList = items && items.get('activeWishList');
  return (activeWishList && activeWishList.subTotal) || 0;
});

export const selectTotalProductsCount = (state) => {
  const activeWishList = selectActiveWishList(state);
  return activeWishList && activeWishList.items.length;
};

export const selectWishListCount = createSelector(getFavoriteListState, (items) => {
  const activeWishList = items && items.get('activeWishList');
  return (activeWishList && activeWishList.itemCount) || 0;
});

export const selectActiveDisplayName = createSelector(getFavoriteListState, (items) => {
  const activeWishList = items && items.get('activeWishList');
  return activeWishList && activeWishList.displayName;
});

export const selectActiveWishlistId = (state) => {
  const activeWishList = selectActiveWishList(state);
  return activeWishList && activeWishList.id;
};

export const selectDefaultWishlist = (state) => {
  const wishlistsSummaries = selectWishlistsSummaries(state);
  return (
    wishlistsSummaries &&
    wishlistsSummaries.length > 0 &&
    wishlistsSummaries.filter((wishlist) => {
      return wishlist.isDefault === true;
    })
  );
};

export const getAllProductsAvailability = (state) => {
  const activeWishList = selectActiveWishList(state);
  let isTcpProductAvailable = false;
  let isGymProductAvailable = false;
  let isSnjProductAvailable = false;
  let isTcpAndGymAndSnjProductsAvailable = false;
  const len = (activeWishList && activeWishList.items.length) || 0;
  for (let i = 0; i < len; i += 1) {
    const item = activeWishList.items[i];
    if (item.itemInfo.brand === TCP) {
      isTcpProductAvailable = true;
    } else if (item.itemInfo.brand === GYM) {
      isGymProductAvailable = true;
    } else if (item.itemInfo.brand === SNJ) {
      isSnjProductAvailable = true;
    }
  }
  isTcpAndGymAndSnjProductsAvailable =
    isTcpProductAvailable && isGymProductAvailable && isSnjProductAvailable;
  return isTcpAndGymAndSnjProductsAvailable;
};

export const getAllBrandsAvailability = (state) => {
  const activeWishList = selectActiveWishList(state);
  const availableBrands = ['', '', ''];
  const len = (activeWishList && activeWishList.items.length) || 0;
  for (let i = 0; i < len; i += 1) {
    const item = activeWishList.items[i];
    if (item.itemInfo.brand === TCP) {
      availableBrands[0] = TCP;
    } else if (item.itemInfo.brand === GYM) {
      availableBrands[1] = GYM;
    } else if (item.itemInfo.brand === SNJ) {
      availableBrands[2] = SNJ;
    } else if (item.itemInfo.brand === PJP) {
      availableBrands[3] = PJP;
    }
  }
  return availableBrands;
};

export const fetchCurrencySymbol = (state) => {
  const currency = state.session && state.session.siteDetails.currency;
  if (currency) {
    return currency === 'USD' || currency === 'CA' ? '$' : currency;
  }
  return '$';
};

export const fetchAddToFavoriteErrorMsg = (state) => {
  return state && state.Favorites && state.Favorites.get('isAddToFavError');
};

export default fetchCurrencySymbol;

export const getIsDataLoading = (state) => {
  return state && state.Favorites && state.Favorites.get('isDataLoading');
};

export const fetchErrorMessages = (state) => {
  return state && state.Favorites && state.Favorites.get('errorMessages');
};

export const getOOSItemIdWhoseSuggestionRequested = (state) => {
  return state && state.Favorites && state.Favorites.get('seeSuggestedItemForOOSItemId');
};

export const selectDefaultWishlistId = (state) => {
  return state && state.Favorites && state.Favorites.get('defaultWishListId');
};

export const getDefaultFavItemInProgressFlag = (state) => {
  return state && state.Favorites && state.Favorites.get('deleteFavItemInProgress');
};

export const getUserWishListSummaryState = (state) => {
  return state && state.Favorites && state.Favorites.get('wishlistsSummariesStatus');
};

const emptyObj = {};
export const getAllUserWishListProducts = (state) => {
  if (getUserWishListSummaryState(state)) {
    const products = [];
    const wishLists = selectWishlistsSummaries(state);
    wishLists.forEach((wishlist) => {
      if (wishlist?.productsList?.length) {
        wishlist.productsList.forEach((item) => {
          if (products.indexOf(item.productId) === -1) {
            products.push(item.productId);
          }
        });
      }
    });
    return products;
  }
  return emptyObj;
};

export const getPendingAddWishlistProduct = (state) => {
  return (
    state[FAVORITES_REDUCER_KEY] && state[FAVORITES_REDUCER_KEY].get('pendingAddWishlistProduct')
  );
};

export const getShowLoginModal = createSelector(getFavoriteListState, (fav) =>
  fav.get('showLoginModal')
);
